import request from '@/utils/request'


export function fetchProductForVoucher(params) {
  return request({
    url:'smsVoucher/getProductListForSelect/',
    method:'get',
    params:params
  })
}

export function fetchVoucherList(params) {
  return request({
    url:'smsVoucher/list/',
    method:'get',
    params:params
  })
}

export function fetchVoucherById(id){
  return request({
    url:'smsVoucher/detail/' + id,
    method:'get'
  })
}

export function fetchVoucherHistoryList(params,voucherNo) {
  return request({
    url:'/smsVoucher/history/'+ voucherNo,
    method:'get',
    params:params
  })
}


export function createVoucher(data) {
  return request({
    url:'/smsVoucher/create',
    method:'post',
    data:data
  })
}


export function createBill(data) {
  return request({
    url:'/smsVoucher/createBill',
    method:'post',
    data:data
  })
}

export function createBulkBill(data){
  return request({
    url:'/smsVoucher/createBulkBill',
    method:'post',
    data:data
  })
}
export function applyBalanceDiscount(data) {
  return request({
    url:'/smsVoucher/applyBalanceDiscount',
    method:'post',
    data:data
  })
}

export function updateVoucher(id, data) {
  return request({
    url:'/smsVoucher/update/' + id,
    method:'post',
    data:data
  })
}

export function updateCrudStatus(id,params) {
  return request({
    url:'/smsVoucher/updateCrudStatus/'+ id,
    method:'post',
    params: params
  })
}



export function calculateVoucherItemAmount(data) {
  return request({
    url:'/smsVoucherItem/calculateVoucherItemAmount',
    method:'post',
    data:data
  })
}


export function getReport(id) {
  return request({
    url:'/smsVoucher/getReport/' + id,
    method:'get',
    responseType: 'blob'
  })
}

export function fetchVoucherItemList(params) {
  return request({
    url:'smsVoucherItem/list/',
    method:'get',
    params:params
  })
}